import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root',
})
export class EbayitemService {
  public url: string;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  verify(token, id): Observable<any> {
    let params = 'authorization=' + token;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http
      .post(this.url + '/ebayitem/verify/' + id + '?page=1', params, { headers: headers })
      .pipe(map((res) => res));
  }

  getItemsByType(token, id, page = null, perPage): Observable<any> {
    let params = 'authorization=' + token;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http
      .post(this.url + '/ebayitem/listbytype/' + id + '?page=' + page + '&perpage=' + perPage, params, { headers: headers })
      .pipe(map((res) => res));
  }

  updatebulk(token, task): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);
    let params = 'json=' + json + '&authorization=' + token;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http
      .post(this.url + '/ebayitem/updatebulk', params, { headers: headers })
      .pipe(map((res) => res));
  }

  hotdeal(token, task): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);
    let params = 'json=' + json + '&authorization=' + token;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http
      .post(this.url + '/ebayitem/sethotdealbulk', params, { headers: headers })
      .pipe(map((res) => res));
  }

  wantedUsers(id): Observable<any> {
    return this._http.get('https://greenteksolutionsllc.com/store/getsubscribers/' + id).pipe(map((res) => res));
  }

  remove(token, id): Observable<any> {
    let params = 'authorization=' + token;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });
    let page = 1;

    return this._http
      .post(this.url + '/chatlog/remove/' + id + '?page=' + page, params, { headers: headers })
      .pipe(map((res) => res));
  }

  removeBulk(token, task): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);
    let params = 'json=' + json + '&authorization=' + token;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http
      .post(this.url + '/ebayitem/remove', params, { headers: headers })
      .pipe(map((res) => res));
  }
}
